import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CloudPaymentsCashierProblemType as SchemaCloudPaymentsCashierProblemType } from '../schemas/CloudPaymentsCashierProblemType';
import { type CloudPaymentsCashierRequest as SchemaCloudPaymentsCashierRequest } from '../schemas/CloudPaymentsCashierRequest';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const SetCloudPaymentsCashierContentType = 'application/json' as const;
export type SetCloudPaymentsCashierRequest = SchemaCloudPaymentsCashierRequest;
export type SetCloudPaymentsCashierResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful creation of data
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaCloudPaymentsCashierProblemType;
        };
    };
};
export type SetCloudPaymentsCashierResponseSuccess = undefined;
export type SetCloudPaymentsCashierSearchParams = undefined;
export type SetCloudPaymentsCashierPathParameters = undefined;
export const SetCloudPaymentsCashierUrl = '/cloudpayments/cashier' as const;
export const SetCloudPaymentsCashierMethod = 'POST' as const;
export const getSetCloudPaymentsCashierUrl = (_params?: SetCloudPaymentsCashierPathParameters) =>
    SetCloudPaymentsCashierUrl;
